import { SecondaryButton } from "..";

export function ThreeDotsButton({ children, className, iconClassName = "size-4 stroke-2", iconColor = "currentcolor", ...props }) {
    return (
        <SecondaryButton className={`h-fit min-h-0 min-w-0 shrink-0 rounded-full !p-1 ${className}`}>
            <p className="-mt-2 ml-px text-center font-bold tracking-widest text-white">...</p>
        </SecondaryButton>
    )
}

